import React, { Component } from 'react';
import ValidationText from '../../utils/validation/ValidationText.js';
import { CommonValidationMessages } from '../../utils/Messages.js';
import moment from 'moment';
import { isValidForm } from '../../utils/validation/CommonValidator.js';

class GstrOneGenerate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noItemFound: "",
            filterDetails: {
                startDate: "",
                endDate: "",
                search: "salesDetails",
            },
            searchList: [
                { search: "Sales Details", value: "salesDetails" },
                { search: "B2cs", value: "b2cs" },
                { search: "HSN Details", value: "hsnDetails" },
                { search: "Docs", value: "docs" },
            ],
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };

    }

    componentDidMount() {
    }
    getAllGSTR = () => {
        let isValidAllFields = this.isValidAllFields();
    }
    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.startDate = ""
        Fdetails.endDate = ""
        Fdetails.search = "salesDetails"
        this.setState({
            filterDetails: Fdetails, noItemFound: "",
        });
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details },
        );

    };
    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details });
    };
    render() {
        return (
            <div>
                <div className="item-search flex gap-2.5 !mb-3">
                    <div className="input-grp w-[20%]" >
                        <label>Start Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")
                            }
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.startDate}
                        /> */}
                    </div>
                    <div className="input-grp w-[20%]">
                        <label>End Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                            type="date"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            value={this.state.filterDetails.endDate}
                            onChange={(event) =>
                                this.handleChange(event, "endDate")
                            }
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.endDate}
                        /> */}
                    </div>
                    <div className="search-grp w-[25%]">
                        <label>Search</label>
                        <select
                            name="search"
                            className="w-full"
                            value={this.state.filterDetails.search
                                && this.state.filterDetails.search !== 'Select'
                                && this.state.searchList.find(
                                    (party) => party.value === this.state.filterDetails.search
                                ).value}
                            onChange={(event) =>
                                this.handleDropDownChange(
                                    event,
                                    "search",
                                    "filterDetails"
                                )
                            }>
                            {this.state.searchList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.search}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="btn-grp mt-auto">
                        <button
                            className={`add-btn mt-auto`}
                            onClick={() => this.getAllGSTR()}>
                            Search
                        </button>
                        <button
                            className={`cancel-btn mt-auto`}
                            onClick={() => this.resetForm()}>
                            Cancel
                        </button>

                    </div>
                </div>
                <div class="item-listing">
                    <div class="itemList-table">
                        <div class="table-container" style={{ height: "calc(100vh - 125px)" }} >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[3%]'>Sr.</td>
                                        <td className='w-[7%]'>Inv No.</td>
                                        <td className='w-[9%]'>Inv Date</td>
                                        <td className='w-[15%]'>Party Name</td>
                                        <td className='w-[12%]'>GSTN No</td>
                                        <td className='w-[8%]'>State</td>
                                        <td className='w-[10%]'>Taxable Amt</td>
                                        <td className='w-[5%]'>GST %</td>
                                        <td className='w-[7%]'>SGST Amt</td>
                                        <td className='w-[7%]'>CGST Amt</td>
                                        <td className='w-[7%]'>IGST Amt</td>
                                        <td className='w-[10%]'>Inv. Amt</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.inwardOutwardPostlist && this.state.inwardOutwardPostlist.length > 0 ? (
                                        this.state.inwardOutwardPostlist.map((details, key) => (
                                            <tr
                                                key={key}
                                            >
                                                <td>{details.category}</td>
                                                <td>{moment(details.date).format('DD MMM YYYY')}</td>
                                                <td>{details.partyId.partyName}</td>
                                                <td>{details.podNo}</td>
                                                <td>{details.narration}</td>
                                            </tr>
                                        ))
                                    ) : this.state.inwardOutwardPostlist && this.state.inwardOutwardPostlist.length === 0 && this.state.noItemFound !== "" ? (
                                        <tr>
                                            <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {this.state.noItemFound}
                                            </td>
                                        </tr>
                                    ) : this.state.inwardOutwardPostlist && this.state.inwardOutwardPostlist.length === 0 && this.state.noItemFound === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GstrOneGenerate;